<template>
  <div class="ProjectInformation">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">作业面维护</span>
      </div>

      <el-container style="height: 80vh" class="myContainer">
        <el-aside width="200px" class="elAside">
          <div class="zTreeDiv">
            <ul id="WorkPlaneTree" class="ztree"></ul>
          </div>
          <div id="WorkPlaneRemenu">
            <ul>
              <li id="addWorkPlane">添加</li>
              <li id="updateWorkPlane">修改</li>
              <li id="WorkPlaneLink">关联</li>
              <li id="delWorkPlane">删除</li>
            </ul>
          </div>
        </el-aside>
        <el-main class="mar-left10">
          <h2>
            {{
              inform.type == 1
              ? "单模"
              : inform.type == 2
                ? "选择集"
                : inform.type == 3
                  ? "合模"
                  : ""
            }}
          </h2>

          <el-table :data="inform.mList" class="w-mar-bot20" heigt="75vh" v-loading="loading">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column align="center" prop="name" label="模型名称"></el-table-column>
            <el-table-column align="center" prop="sname" label="选择集名称"></el-table-column>
            <el-table-column align="center" prop="vmark" label="版本备注"></el-table-column>
            <el-table-column align="center" prop="time" label="更新时间"></el-table-column>
          </el-table>
        </el-main>
      </el-container>

      <el-dialog :close-on-click-modal="false" title="模型选择集" :visible.sync="associatedOpen" width="40%" center>
        <!-- <p style="color:red;text-align:center;margin-bottom:10px">提示：若仅选择模型，不勾选选择集，则表示关联整个模型。</p> -->
        <p class="text-p">
          请注意，类型为单模或选择集时，只能选择一个模型;为合模时支持多个合并加载。
          <br />保存视点和选择集操作只对单模型类型可用。
        </p>
        <el-row class="pad-bot0">
          <el-col :span="5">
            <el-select filterable v-model="selectType" @change="removeModelList" placeholder="请选择">
              <el-option v-for="item in pgList" :key="item.index" :label="item.value" :value="item.index"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-select filterable v-model="modelName" @change="handleClick" placeholder="模型名称">
              <el-option v-for="item in ModelList" :key="item.mode01" :label="item.mode02"
                :value="[item.mode01, item.mode02, item]"></el-option>
            </el-select>
          </el-col>
          <el-col v-if="selectType != 1" :span="7" :offset="1">
            <el-select v-if="selectType == 2" v-model="sName" @change="selectChange" filterable placeholder="选择集">
              <el-option v-for="item in GetModelSelectList" :key="item.mosl01" :label="item.mosl02"
                :value="[item.mosl01, item.mosl02, item]"></el-option>
            </el-select>
            <el-select v-if="selectType == 3" clearable v-model="sName" filterable placeholder="版本名称"
              @change="selectChange">
              <el-option v-for="item in GetModelSelectList" :key="item.mode01" :label="item.mode02"
                :value="[item.mode01, item.mode02, item]"></el-option>
            </el-select>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-button plain type="primary" class="width100" @click="addModel">添加</el-button>
          </el-col>
          <!-- <el-col :span="4">
            <el-select filterable v-model="pgListName" placeholder="请选择">
              <el-option
                v-for="item in pgList"
                :key="item.index"
                :label="item.value"
                :value="item.index"
              ></el-option>
            </el-select>
          </el-col>-->
          <!-- <el-col :span="13">
            <div class="head-text" style="float:right;margin-top: -4px;">
              <el-input
                placeholder="请输入模型名称"
                style="width:200px"
                class="search-input"
                v-model="query2"
              ></el-input>
              <el-button slot="append" icon="el-icon-search" @click="GetModelSelect" style="margin-right:80px"></el-button>
            </div>
          </el-col>-->
        </el-row>
        <div v-if="modelData" style="height:200px;overflow: auto;">
          <el-row>
            <el-col :span="2">
              序号
            </el-col>
            <el-col :span="6" :offset="1">
              模型名称
            </el-col>
            <el-col :span="6" :offset="1">
              选择集
            </el-col>
            <el-col :span="5">
              版本备注
            </el-col>
            <el-col :span="3">
              操作
            </el-col>
          </el-row>
          <el-row v-for="(item, index) in modelData" :key="index">
            <el-col :span="2">
              <p class="cor00c">{{ index + 1 }}</p>
            </el-col>
            <el-col :span="6" :offset="1">
              <p class="cor00c">{{ item.modelName }}</p>
            </el-col>
            <el-col :span="6" :offset="1">
              <p class="cor00c">{{ item.sname }}</p>
            </el-col>
            <el-col :span="5">
              <p class="cor00c">{{ item.versionInfo||'--' }}</p>
            </el-col>
            <el-col :span="3">
              <el-button type="danger" size="small" plain @click="deleteList(index)">删除</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- <el-table
          ref="multipleTable"
          :data="GetModelSelectList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            prop="mosl02"
            label="名字"
          ></el-table-column>
        </el-table>-->
        <el-row>
          <el-col :span="2" :offset="11">
            <el-button type="primary" @click="modelChooseListTrue">确定</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  GetWorkPlaneZTree,
  DelPwokPlane,
  AddPwokPlane,
  ExamineProjectJob,
  EditPworkPlane,
  GetModelSelect,
  GetProjectModelList,
  FindPworkPlane,
  ChangePworkPlaneOrder,
  GetWorkPlaneLinkModes,
  EditPworkPlaneName,
  GetModelVersionsList,
} from "@/setAxios.js";
import { versions } from "process";
export default {
  name: "ProjectInformation",
  data() {
    return {
      ids: "null",
      zNodes: null,
      selectNode: null,
      zTeeObj: null,
      // 版本名称
      versions: null,
      // 单模/合模型
      modelData: [],
      // 版本对象
      versionsList: [],
      zymId: "",
      zymInfo: null,
      query2: "",
      pgListName: 1,
      selectType: 1,
      GetModelSelectList: [],
      ModelList: "",
      pgList: [
        { index: 1, value: "单模" },
        { index: 2, value: "选择集" },
        { index: 3, value: "合模" },
      ],
      mid: "",
      modelName: [],
      associatedOpen: false,
      loading: false,
      total: 0,
      pagesize: 10,
      pagenum: 1,
      multipleSelection: [],
      addDialogFormVisible: false,
      inform: { type: "", mList: [] },
      froms: {
        wopl02: localStorage.getItem("xid"),
        wopl08: 0,
        wopl09: new Date(),
        wopl10: 0,
      },
      menuId: "",
      selectModel: null,
      modelSelect: null,
      sName: "", //选择集名字
    };
  },
  methods: {
    //选择集、模型版本
    selectChange(data) {
      if (data) {
        this.versions = data;
      } else {
        this.versions = null;
      }
    },
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "wopl03",
          },
          simpleData: {
            enable: true,
            idKey: "wopl01",
            pIdKey: "wopl08",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          beforeDrop: beforeDrop,
          onClick: onclick,
        },
      };

      this.zTeeObj = $.fn.zTree.init($("#WorkPlaneTree"), setting, this.zNodes);
      if (this.zTeeObj != null) {
        $("#WorkPlaneTree_1_a").click();
      }

      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            ChangePworkPlaneOrder({
              oid: moveNode.wopl01,
              nid: targetNode.wopl01,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: "移动成功",
            });
            return true;
            break;
        }
        return false;
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.menuId = treeNode.wopl01;
        _this.getData();
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "WorkPlaneRemenu" ||
            $(event.target).parents("#WorkPlaneRemenu").length > 0
          )
        ) {
          $("#WorkPlaneRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addWorkPlane").show();
          $("#updateWorkPlane").hide();
          $("#delWorkPlane").hide();
          $("#WorkPlaneLink").hide();
        } else {
          $("#addWorkPlane").show();
          $("#updateWorkPlane").show();
          $("#delWorkPlane").show();
          $("#WorkPlaneLink").show();
        }
        $("#WorkPlaneRemenu").show();
        $("#WorkPlaneRemenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#WorkPlaneRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#WorkPlaneRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addWorkPlane") {
            var newNode = {},
              params = {};
            var node = _this.selectNode;
            params = {
              wopl01: 0,
              wopl02: localStorage.getItem("xid"),
              wopl03: "新建作业面",
              wopl05: 1,
              wopl08: _this.selectNode == null ? 0 : _this.selectNode.wopl01,
              wopl09: new Date(),
              wopl10: 0,
            };
            AddPwokPlane(params).then((res) => {
              if (res.Code > 0) {
                _this.$message({
                  type: "success",
                  message: "添加成功",
                });
                newNode = res.Data;
                _this.zTeeObj.addNodes(_this.selectNode, newNode);
                var currentNode = _this.zTeeObj.getNodeByParam(
                  "wopl01",
                  newNode.wopl01
                );
                _this.zTeeObj.selectNode(currentNode);
                _this.zTeeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "waring",
                  message: "添加失败",
                });
              }
            });
          } else if (type == "delWorkPlane") {
            _this.$confirm("确认删除当前以及附属节点？").then((_) => {
              var ids = _this.zTeeObj
                .transformToArray(_this.selectNode)
                .map((item) => item.wopl01)
                .join(",");
              let params = { id: ids };
              DelPwokPlane(params).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  var currentNode = _this.zTeeObj.getNodeByParam(
                    "wopl01",
                    _this.selectNode.wopl01
                  );
                  _this.zTeeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "warning",
                    message: "删除失败",
                  });
                }
              });
            });
          } else if (type == "WorkPlaneLink") {
            _this.associated(_this.selectNode);
          } else {
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.wopl03) {
          let params = {
            id: treeNode.wopl01,
            name: newName,
          };
          EditPworkPlaneName(params).then((res) => {
            _this.$message({
              type: "success",
              message: "更新成功",
            });
          });
        }
      }
    },

    // 删除数据按钮
    deleteList(i) {
      this.modelData.splice(i, 1);
    },
    // 切换单模/合模型清除数组
    removeModelList() {
      this.modelData = [];
      if (this.selectType == 2) {
        this.GetModelSelect();
      } else if (this.selectType == 3) {
        this.GetModelVersionList();
      }
    },
    GetModelVersionList() {
      GetModelVersionsList({ mid: this.selectModel[2].mode15 }).then((res) => {
        this.GetModelSelectList = res.Data;
        if (this.GetModelSelectList.length) {
          this.sName = this.GetModelSelectList[0].mode02;
          this.versions = [
            this.GetModelSelectList[0].mode01,
            this.GetModelSelectList[0].mode02,
            this.GetModelSelectList[0],
          ];
        } else {
          this.sName = "";
          this.versions = null;
        }
      });
    },
    // 添加按钮
    addModel() {
      if (this.selectType == 1) {
        if (!this.selectModel) {
          this.$message.error("模型列表为空！");
        } else if (this.selectModel) {
          if (this.modelData.length >= 1) {
            this.$message.error("单模只能选择一个！");
          } else {
            this.modelData.push({
              modelName: this.selectModel[1],
              versionInfo: this.selectModel[2].mode05,
              sname: "--",
              modelId: this.selectModel[0],
              type: this.selectType,
            });
          }
        } else {
          this.$message.error("列表为空！");
          return;
        }
      } else if (this.selectType == 2) {
        if (!this.versions) {
          this.$message.error("选择集列表为空！");
        } else if (this.modelData.length >= 1) {
          this.$message.error("关联一个选择集!");
        } else {
          this.modelData.push({
            modelName: this.selectModel[1],
            versionInfo: this.selectModel[2].mode05,
            sname: this.versions[1],
            modelId: this.selectModel.mode01,
            selectId: this.versions[0],
            type: this.selectType,
          });
        }
      } else if (this.selectType == 3) {
        if (this.versions) {
          this.modelData.push({
            modelName: this.versions[1],
            versionInfo: this.versions[2].mode05,
            sname: "--",
            modelId: this.versions[0],
            type: this.selectType,
          });
        } else if (this.selectModel) {
          this.modelData.push({
            modelName: this.selectModel[1],
            versionInfo: this.selectModel[2].mode05,
            sname: "--",
            modelId: this.selectModel[0],
            type: this.selectType,
          });
        }
        this.modelData = this.uniqueFun(this.modelData, "modelId");
      }
    },
    uniqueFun(arr, type) {
      const res = new Map();
      return arr.filter((a) => !res.has(a[type]) && res.set(a[type], 1));
    },
    // 关联
    associated(row) {
      this.zymId = row.wopl01;
      this.associatedOpen = true;
      var params = {
        xid: row.wopl02,
        seachword: "",
        pageSize: 1000000,
        pageIndex: 1,
      };
      GetProjectModelList({ params }).then((res) => {
        this.ModelList = res.Data.list;
        if (this.ModelList.length) {
          this.mid = this.ModelList[0].mode01;
          this.modelName = this.ModelList[0].mode02;
          this.selectModel = [
            this.ModelList[0].mode01,
            this.ModelList[0].mode02,
            this.ModelList[0],
          ];
        } else {
          this.mid = "";
          this.modelName = "";
          this.selectModel = "";
        }
      });
      var params = {
        id: this.zymId,
      };
      FindPworkPlane({ params }).then((res) => {
        this.zymInfo = res.Data;
      });
    },
    // 选择集
    GetModelSelect() {
      let params = {
        seachword: this.query2,
        mid: this.mid,
      };
      GetModelSelect({ params }).then((res) => {
        this.GetModelSelectList = res.Data;
        if (this.GetModelSelectList.length) {
          this.sName = this.GetModelSelectList[0].mosl02;
          this.versions = [
            this.GetModelSelectList[0].mosl01,
            this.GetModelSelectList[0].mosl02,
            this.GetModelSelectList[0],
          ];
        } else {
          this.sName = "";
          this.versions = null;
        }
      });
    },
    // 关联确定
    modelChooseListTrue() {
      if (this.modelData.length > 0) {
        this.zymInfo.wopl05 = 1;
        this.zymInfo.wopl07 = this.selectType;
        if (this.selectType == 1) {
          this.zymInfo.wopl06 = this.mid;
        } else if (this.selectType == 2) {
          this.zymInfo.wopl06 = this.modelData[0].selectId;
        } else {
          let ids = "",
            _split = "";
          this.modelData.forEach((v) => {
            ids += _split + v.modelId;
            _split = ",";
          });
          this.zymInfo.wopl06 = ids;
        }
        let params = this.zymInfo;
        EditPworkPlane({ pwok: JSON.stringify(params) }).then((res) => {
          if (res.Code == 1) {
            this.$message({
              type: "success",
              message: "关联成功",
            });
            this.getZtreeData();
            this.modelData = [];
            this.associatedOpen = false;
          }
        });
      } else {
        this.$message.error("请先添加关联数据!");
        return;
      }
    },
    // 这里是切换模型
    handleClick(data) {
      this.mid = data[0];
      this.selectModel = data;
      if (this.selectType == 2) {
        this.versions = null;
        this.sName = "";
        this.GetModelSelect();
      } else if (this.selectType == 3) {
        this.versions = null;
        this.sName = "";
        this.GetModelVersionList();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
    },
    handleCurrentChange(val) {
      this.pagenum = val;
    },
    // 获取所有数据
    getData() {
      GetWorkPlaneLinkModes({ id: this.menuId }).then((res) => {
        if (res.Data) {
          this.inform = res.Data;
        } else {
          this.inform = { type: "", mList: [] };
        }
      });
    },
    getZtreeData() {
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetWorkPlaneZTree({ params }).then((res) => {
        this.zNodes = res.Data;
        this.zNodes.forEach((v) => {
          if (v.wopl07 == 1) {
            v.iconSkin = "pIcon01";
          } else if (v.wopl07 == 2) {
            v.iconSkin = "pIcon02";
          } else if (v.wopl07 == 3) {
            v.iconSkin = "pIcon03";
          } else {
            v.iconSkin = "pIcon04";
          }
        });
        this.init();
      });
    },
    // 新增
    addData() {
      this.addDialogFormVisible = true;
    },
    // 新增确定按钮
    addUserSubmit() {
      let parmas = {
        pwok: JSON.stringify(this.froms),
      };
      AddPwokPlane(parmas).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.getData();
          this.addDialogFormVisible = false;
        } else {
          this.$message.error("新增失败");
        }
      });
    },
  },
  created() {
    // this.getData();
  },
  mounted() {
    this.getZtreeData();
  },
};
</script>

<style lang="less" scoped>
// /deep/ .el-dialog__body {
//   padding-bottom: 20px;
// }
// .rygl-table {
//   /deep/ .is-leaf {
//     position: relative;
//     &::before {
//       content: "";
//       position: absolute;
//       width: 20px;
//       height: 20px;
//       left: 24px;
//       background-size: 100%;
//     }
//   }
//   /deep/ .is-leaf:nth-child(8) {
//     left: 12px;
//     &::before {
//       top: 13px;
//       background: url("../../../../assets/img/cz.png");
//       background-size: 100%;
//       left: 40%;
//     }
//   }
//   /deep/ .is-leaf:nth-child(7) {
//     left: 12px;
//     &::before {
//       top: 13px;
//       background: url("../../../../assets/img/sj.png");
//       background-size: 100%;
//       left: 24%;
//     }
//   }
//   /deep/ .is-leaf:nth-child(4) {
//     left: 8px;
//     &::before {
//       top: 14px;
//       background: url("../../../../assets/img/yd.png");
//       background-size: 100%;
//       left: 28%;
//     }
//   }
//   // /deep/ .is-leaf:nth-child(4) {
//   //   left: 10px;
//   //   &::before {
//   //     top: 13px;
//   //     background: url("../../../../assets/img/ren.png");
//   //     background-size: 100%;
//   //     left: 30%;
//   //   }
//   // }
//   /deep/ .is-leaf:nth-child(3) {
//     left: 8px;
//     &::before {
//       top: 13px;
//       background: url("../../../../assets/img/ztt.png");
//       background-size: 100%;
//       left: 30%;
//     }
//   }
//   /deep/ .is-leaf:nth-child(6) {
//     left: 8px;
//     &::before {
//       top: 13px;
//       background: url("../../../../assets/img/sort.png");
//       background-size: 100%;
//       left: 30%;
//     }
//   }
// }
div#WorkPlaneRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#WorkPlaneRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#WorkPlaneRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#WorkPlaneRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#WorkPlaneTree {
  height: 500px;
}

.zTreeDiv {
  height: 100%;
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

.userManagement .search-input {
  width: 300px;
}

// 新增
.font-sz24 {
  font-size: 24px;
}

.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}

.mar-left10 {
  margin-left: 10px;
}

.w-mar-bot20 {
  width: 100%;
  margin-bottom: 20px;
}

.text-p {
  color: red;
  text-align: center;
  margin-bottom: 10px;
}

.pad-bot0 {
  padding-bottom: 0;
}

.width100 {
  width: 100%;
}

.cor00c {
  color: #00c4ff;
}
</style>
